import Chip from '@material-ui/core/Chip';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import ChipContainer from '../../../common/ChipContainer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    topSection: {
      marginBottom: 24
    },
    largeGutter: {
      marginBottom: 8
    }
  })
);

interface Props {
  workflow: any;
}

function WorkflowNotifications(props: Props) {
  const { workflow } = props;
  const classes = useStyles({});

  return (
    <div>
      <div className={classes.topSection}>
        <Typography variant="subtitle1">SNS Topic</Typography>
        <Typography display="block" variant="caption" gutterBottom>
          Topic you can subscribe to for notifications when your workflow execution completes
        </Typography>
        <Typography color="textSecondary">{workflow.NotificationTopicARN}</Typography>
      </div>
      <div>
        <Typography variant="subtitle1">Users</Typography>
        <Typography display="block" variant="caption" className={classes.largeGutter}>
          The following users will be notified of workflow results:
        </Typography>
        <ChipContainer>
          {workflow.Notifiers.map(user => <Chip key={user} label={user} variant="outlined" />)}
        </ChipContainer>
      </div>
    </div>
  );
};

export default WorkflowNotifications;
